module.exports = __webpack_public_path__ + "static/media/house55.2ec21deb.svg";